// import React, { useEffect, useState } from "react";
// import { Card, Col, Container, Row, Table } from "react-bootstrap";
// import Breadcrumb from "Common/BreadCrumb";

// // Import Images
// import logoDark from "assets/images/anjal-gold-logo.png";
// import logoLight from "assets/images/anjal-gold-logo.png";
// import { Link, useParams } from "react-router-dom";
// import { getInvoiceByNumber } from "api/apis";

// const InvoiceDetails = () => {
//   const [invoice, setInvoice] = useState<any>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Print the Invoice
//   const printInvoice = () => {
//     window.print();
//   };

//   const { invoiceId } = useParams();

//   // Decode the URI component to get the original ID with #
//   const decodedInvoiceId = decodeURIComponent(invoiceId || "");

//   useEffect(() => {
//     console.log("Invoice ID:", decodedInvoiceId); // Will show #TN25000355

//     if (!decodedInvoiceId) {
//       console.error("No invoice ID found");
//       return;
//     }

//     // Fetch your invoice data using decodedInvoiceId
//     const fetchInvoice = async () => {
//       try {
//         const data = await getInvoiceByNumber(decodedInvoiceId);
//         console.log(data, "iksdtgjdfi");

//         setInvoice(data.invoice);
//       } catch (error) {
//         console.error("Error fetching invoice:", error);
//       }
//     };

//     fetchInvoice();
//   }, [decodedInvoiceId]);

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid={true}>
//           <Breadcrumb title="Invoice Details" pageTitle="Invoices" />

//           <Row className="justify-content-center">
//             <Col xxl={9}>
//               <Card id="demo">
//                 <Row>
//                   <Col lg={12}>
//                     <Card.Header className="border-bottom-dashed p-4">
//                       <div className="d-sm-flex">
//                         <div className="flex-grow-1">
//                           <img
//                             src={logoDark}
//                             className="card-logo card-logo-dark"
//                             alt="logo dark"
//                             height="100"
//                           />
//                           <img
//                             src={logoLight}
//                             className="card-logo card-logo-light"
//                             alt="logo light"
//                             height="100"
//                           />
//                           <div className="mt-sm-5 mt-4">
//                             <h6 className="text-muted text-uppercase fw-semibold fs-14">
//                               Address
//                             </h6>
//                             <p className="text-muted mb-1" id="address-details">
//                               Mumbai, Maharashtra
//                             </p>
//                             <p className="text-muted mb-0" id="zip-code">
//                               <span>Zip-code:</span> 400001
//                             </p>
//                           </div>
//                         </div>
//                         <div className="flex-shrink-0 mt-sm-0 mt-3">
//                           <h6>
//                             <span className="text-muted fw-normal">
//                               Legal Registration No:
//                             </span>{" "}
//                             <span id="legal-register-no">987654</span>
//                           </h6>
//                           <h6>
//                             <span className="text-muted fw-normal">Email:</span>{" "}
//                             <span id="email">anjal@gmail.com</span>
//                           </h6>
//                           <h6>
//                             <span className="text-muted fw-normal">
//                               Website:
//                             </span>{" "}
//                             <Link
//                               to="https://anjalgold-frontend.vercel.app/"
//                               className="link-primary"
//                               target="_blank"
//                               id="website"
//                             >
//                               www.anjalgold.com
//                             </Link>
//                           </h6>
//                           <h6 className="mb-0">
//                             <span className="text-muted fw-normal">
//                               Contact No:{" "}
//                             </span>
//                             <span id="contact-no"> +(91) 123 456 7898</span>
//                           </h6>
//                         </div>
//                       </div>
//                     </Card.Header>
//                   </Col>
//                   <Col lg={12}>
//                     <Card.Body className="p-4">
//                       <Row className="g-3">
//                         <Col lg={3} className="col-6">
//                           <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
//                             Invoice No
//                           </p>
//                           <h5 className="fs-15 mb-0">
//                             #TTB<span id="invoice-no">30280001</span>
//                           </h5>
//                         </Col>
//                         <Col lg={3} className="col-6">
//                           <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
//                             Date
//                           </p>
//                           <h5 className="fs-15 mb-0">
//                             <span id="invoice-date">14 Jan, 2023</span>{" "}
//                             <small className="text-muted" id="invoice-time">
//                               12:22PM
//                             </small>
//                           </h5>
//                         </Col>
//                         <Col lg={3} className="col-6">
//                           <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
//                             Payment Status
//                           </p>
//                           <span
//                             className="badge bg-success-subtle text-success"
//                             id="payment-status"
//                           >
//                             Paid
//                           </span>
//                         </Col>
//                         <Col lg={3} className="col-6">
//                           <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
//                             Total Amount
//                           </p>
//                           <h5 className="fs-15 mb-0">
//                             ₹<span id="total-amount">1406.92</span>
//                           </h5>
//                         </Col>
//                       </Row>
//                     </Card.Body>
//                   </Col>
//                   <Col lg={12}>
//                     <Card.Body className="p-4 border-top border-top-dashed">
//                       <Row className="g-3">
//                         <Col className="col-6">
//                           <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">
//                             Billing Address
//                           </h6>
//                           <p className="fw-medium mb-2 fs-16" id="billing-name">
//                             Vinod Kumar
//                           </p>
//                           <p
//                             className="text-muted mb-1"
//                             id="billing-address-line-1"
//                           >
//                             4430 Holt Street, Mumbai-400001
//                           </p>
//                           <p className="text-muted mb-1">
//                             <span>Phone: +</span>
//                             <span id="billing-phone-no">(91) 561-238-1000</span>
//                           </p>
//                           <p className="text-muted mb-0">
//                             <span>Tax: </span>
//                             <span id="billing-tax-no">65-498700</span>{" "}
//                           </p>
//                         </Col>

//                         <Col className="col-6">
//                           <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">
//                             Shipping Address
//                           </h6>
//                           <p
//                             className="fw-medium mb-2 fs-16"
//                             id="shipping-name"
//                           >
//                             Vinod Kumar
//                           </p>
//                           <p
//                             className="text-muted mb-1"
//                             id="shipping-address-line-1"
//                           >
//                             4430 Holt Street, Mumbai-33169
//                           </p>
//                           <p className="text-muted mb-1">
//                             <span>Phone: +</span>
//                             <span id="shipping-phone-no">
//                               (91) 561-238-1000
//                             </span>
//                           </p>
//                         </Col>
//                       </Row>
//                     </Card.Body>
//                   </Col>
//                   <Col lg={12}>
//                     <Card.Body className="p-4">
//                       <div className="table-responsive">
//                         <Table className="table-borderless text-center table-nowrap align-middle mb-0">
//                           <thead>
//                             <tr className="table-active">
//                               <th scope="col" style={{ width: "50px" }}>
//                                 #
//                               </th>
//                               <th scope="col">Product Details</th>
//                               <th scope="col">Rate</th>
//                               <th scope="col">Quantity</th>
//                               <th scope="col" className="text-end">
//                                 Amount
//                               </th>
//                             </tr>
//                           </thead>
//                           <tbody id="products-list">
//                             <tr>
//                               <th scope="row">01</th>
//                               <td className="text-start">
//                                 <span className="fw-medium">
//                                   Black Beaded Mangalsutra
//                                 </span>
//                                 <p className="text-muted mb-0">
//                                   Handcraft Design
//                                 </p>
//                               </td>
//                               <td>₹266.24</td>
//                               <td>03</td>
//                               <td className="text-end">₹798.72</td>
//                             </tr>
//                             <tr>
//                               <th scope="row">02</th>
//                               <td className="text-start">
//                                 <span className="fw-medium">
//                                   Gold Necklace Set
//                                 </span>
//                                 <p className="text-muted mb-0">
//                                   large display of 40mm (1.6″ inch)
//                                 </p>
//                               </td>
//                               <td>₹247.27</td>
//                               <td>01</td>
//                               <td className="text-end">₹247.27</td>
//                             </tr>
//                             <tr>
//                               <th scope="row">03</th>
//                               <td className="text-start">
//                                 <span className="fw-medium">Gold Earrings</span>
//                                 <p className="text-muted mb-0">18k Carat</p>
//                               </td>
//                               <td>₹24.07</td>
//                               <td>05</td>
//                               <td className="text-end">₹120.35</td>
//                             </tr>
//                             <tr>
//                               <th scope="row">04</th>
//                               <td className="text-start">
//                                 <span className="fw-medium">Gold Rings</span>
//                                 <p className="text-muted mb-0">
//                                   Handcrafted Design
//                                 </p>
//                               </td>
//                               <td>₹209.99</td>
//                               <td>01</td>
//                               <td className="text-end">₹209.99</td>
//                             </tr>
//                           </tbody>
//                         </Table>
//                       </div>
//                       <div className="border-top border-top-dashed mt-2">
//                         <Table
//                           className="table-borderless table-nowrap align-middle mb-0 ms-auto"
//                           style={{ width: "250px" }}
//                         >
//                           <tbody>
//                             <tr>
//                               <td>Sub Total</td>
//                               <td className="text-end">₹1376.33</td>
//                             </tr>
//                             <tr>
//                               <td>Estimated Tax (12.5%)</td>
//                               <td className="text-end">₹172.04</td>
//                             </tr>
//                             <tr>
//                               <td>
//                                 Discount{" "}
//                                 <small className="text-muted">(TONER50)</small>
//                               </td>
//                               <td className="text-end">- ₹206.45</td>
//                             </tr>
//                             <tr>
//                               <td>Shipping Charge</td>
//                               <td className="text-end">₹65.00</td>
//                             </tr>
//                             <tr className="border-top border-top-dashed fs-15">
//                               <th scope="row">Total Amount</th>
//                               <th className="text-end">₹1406.92</th>
//                             </tr>
//                           </tbody>
//                         </Table>
//                       </div>
//                       <div className="mt-3">
//                         <h6 className="text-muted text-uppercase fw-semibold mb-3">
//                           Payment Details:
//                         </h6>
//                         <p className="text-muted mb-1">
//                           Payment Method:{" "}
//                           <span className="fw-medium" id="payment-method">
//                             Mastercard
//                           </span>
//                         </p>
//                         <p className="text-muted mb-1">
//                           Card Holder:{" "}
//                           <span className="fw-medium" id="card-holder-name">
//                             Vinod Kumar
//                           </span>
//                         </p>
//                         <p className="text-muted mb-1">
//                           Card Number:{" "}
//                           <span className="fw-medium" id="card-number">
//                             xxx xxxx xxxx 1234
//                           </span>
//                         </p>
//                         <p className="text-muted">
//                           Total Amount: <span className="fw-medium">₹</span>
//                           <span id="card-total-amount">1406.92</span>
//                         </p>
//                       </div>
//                       <div className="mt-4">
//                         <div className="alert alert-info">
//                           <p className="mb-0">
//                             <span className="fw-semibold">NOTES:</span>
//                             <span id="note">
//                               {" "}
//                               All accounts are to be paid within 7 days from
//                               receipt of invoice. To be paid by cheque or credit
//                               card or direct payment online. If account is not
//                               paid within 7 days the credits details supplied as
//                               confirmation of work undertaken will be charged
//                               the agreed quoted fee noted above.
//                             </span>
//                           </p>
//                         </div>
//                       </div>
//                       <div className="hstack gap-2 justify-content-end d-print-none mt-4">
//                         <Link
//                           onClick={printInvoice}
//                           to="#"
//                           className="btn btn-success"
//                         >
//                           <i className="ri-printer-line align-bottom me-1"></i>{" "}
//                           Print
//                         </Link>
//                         <Link to="#" className="btn btn-primary">
//                           <i className="ri-download-2-line align-bottom me-1"></i>{" "}
//                           Download
//                         </Link>
//                       </div>
//                     </Card.Body>
//                   </Col>
//                 </Row>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default InvoiceDetails;

import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row, Table } from "react-bootstrap";
import Breadcrumb from "Common/BreadCrumb";

// Import Images
import logoDark from "assets/images/anjal-gold-logo.png";
import logoLight from "assets/images/anjal-gold-logo.png";
import { Link, useParams } from "react-router-dom";
import { getInvoiceByNumber } from "api/apis";

interface InvoiceItem {
  productName: string;
  productDetails: string;
  purity: string;
  weight: number;
  pricePerGram: number;
  quantity: number;
  totalPrice: number;
  _id: string;
}

interface InvoiceData {
  _id: string;
  invoiceNumber: string;
  date: string;
  paymentStatus: string;
  companyInfo: {
    logo: string;
    address: string;
    postalCode: string;
    registrationNumber: string;
    email: string;
    website: string;
    contactNumber: string;
  };
  customer: {
    name: string;
    email: string;
  };
  billingAddress: {
    street: string;
    city: string;
    postalCode: string;
    state: string;
  };
  shippingAddress: {
    street: string;
    city: string;
    postalCode: string;
    state: string;
  };
  items: InvoiceItem[];
  subTotal: number;
  taxes: number;
  discounts: number;
  finalAmount: number;
  paymentMode: string;
  paymentDetails: string;
  notes: string;
  sameAsBilling: boolean;
  isSent: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

const InvoiceDetails = () => {
  const [invoice, setInvoice] = useState<InvoiceData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Print the Invoice
  const printInvoice = () => {
    window.print();
  };

  const { invoiceId } = useParams();

  // Decode the URI component to get the original ID with #
  const decodedInvoiceId = decodeURIComponent(invoiceId || "");

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setLoading(true);
        const response = await getInvoiceByNumber(decodedInvoiceId);
        setInvoice(response.invoice);
      } catch (error) {
        console.error("Error fetching invoice:", error);
        setError("Failed to load invoice data");
      } finally {
        setLoading(false);
      }
    };

    if (decodedInvoiceId) {
      fetchInvoice();
    }
  }, [decodedInvoiceId]);

  // Helper function to format date
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Helper function to format address
  const formatAddress = (address: {
    street: string;
    city: string;
    postalCode: string;
    state: string;
  }) => {
    return `${address.street}, ${address.city}, ${address.state} ${address.postalCode}`;
  };

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid={true}>
          <div className="text-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid={true}>
          <div className="alert alert-danger my-5">{error}</div>
        </Container>
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="page-content">
        <Container fluid={true}>
          <div className="alert alert-warning my-5">Invoice not found</div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Invoice Details" pageTitle="Invoices" />

          <Row className="justify-content-center">
            <Col xxl={9}>
              <Card id="demo">
                <Row>
                  <Col lg={12}>
                    <Card.Header className="border-bottom-dashed p-4">
                      <div className="d-sm-flex">
                        <div className="flex-grow-1">
                          <img
                            src={logoDark}
                            className="card-logo card-logo-dark"
                            alt="logo dark"
                            height="100"
                          />
                          <img
                            src={logoLight}
                            className="card-logo card-logo-light"
                            alt="logo light"
                            height="100"
                          />
                          <div className="mt-sm-5 mt-4">
                            <h6 className="text-muted text-uppercase fw-semibold fs-14">
                              Address
                            </h6>
                            <p className="text-muted mb-1" id="address-details">
                              {invoice.companyInfo.address}
                            </p>
                            <p className="text-muted mb-0" id="zip-code">
                              <span>Zip-code:</span>{" "}
                              {invoice.companyInfo.postalCode}
                            </p>
                          </div>
                        </div>
                        <div className="flex-shrink-0 mt-sm-0 mt-3">
                          <h6>
                            <span className="text-muted fw-normal">
                              Legal Registration No:
                            </span>{" "}
                            <span id="legal-register-no">
                              {invoice.companyInfo.registrationNumber}
                            </span>
                          </h6>
                          <h6>
                            <span className="text-muted fw-normal">Email:</span>{" "}
                            <span id="email">{invoice.companyInfo.email}</span>
                          </h6>
                          <h6>
                            <span className="text-muted fw-normal">
                              Website:
                            </span>{" "}
                            <Link
                              to={invoice.companyInfo.website}
                              className="link-primary"
                              target="_blank"
                              id="website"
                            >
                              {invoice.companyInfo.website}
                            </Link>
                          </h6>
                          <h6 className="mb-0">
                            <span className="text-muted fw-normal">
                              Contact No:{" "}
                            </span>
                            <span id="contact-no">
                              {invoice.companyInfo.contactNumber}
                            </span>
                          </h6>
                        </div>
                      </div>
                    </Card.Header>
                  </Col>
                  <Col lg={12}>
                    <Card.Body className="p-4">
                      <Row className="g-3">
                        <Col lg={3} className="col-6">
                          <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
                            Invoice No
                          </p>
                          <h5 className="fs-15 mb-0">
                            {invoice.invoiceNumber}
                          </h5>
                        </Col>
                        <Col lg={3} className="col-6">
                          <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
                            Date
                          </p>
                          <h5 className="fs-15 mb-0">
                            {formatDate(invoice.date)}
                          </h5>
                        </Col>
                        <Col lg={3} className="col-6">
                          <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
                            Payment Status
                          </p>
                          <span
                            className={`badge ${
                              invoice.paymentStatus === "Paid"
                                ? "bg-success-subtle text-success"
                                : invoice.paymentStatus === "Unpaid"
                                ? "bg-warning-subtle text-warning"
                                : "bg-danger-subtle text-danger"
                            }`}
                            id="payment-status"
                          >
                            {invoice.paymentStatus}
                          </span>
                        </Col>
                        <Col lg={3} className="col-6">
                          <p className="text-muted mb-2 text-uppercase fw-semibold fs-14">
                            Total Amount
                          </p>
                          <h5 className="fs-15 mb-0">
                            ₹{invoice.finalAmount.toFixed(2)}
                          </h5>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Col>
                  <Col lg={12}>
                    <Card.Body className="p-4 border-top border-top-dashed">
                      <Row className="g-3">
                        <Col className="col-6">
                          <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">
                            Billing Address
                          </h6>
                          <p className="fw-medium mb-2 fs-16" id="billing-name">
                            {invoice.customer.name}
                          </p>
                          <p
                            className="text-muted mb-1"
                            id="billing-address-line-1"
                          >
                            {invoice.billingAddress.street}
                          </p>
                          <p className="text-muted mb-1">
                            {invoice.billingAddress.city},{" "}
                            {invoice.billingAddress.state}{" "}
                            {invoice.billingAddress.postalCode}
                          </p>
                          <p className="text-muted mb-0">
                            <span>Email: </span>
                            <span id="billing-email">
                              {invoice.customer.email}
                            </span>
                          </p>
                        </Col>

                        <Col className="col-6">
                          <h6 className="text-muted text-uppercase fw-semibold fs-14 mb-3">
                            Shipping Address
                          </h6>
                          <p
                            className="fw-medium mb-2 fs-16"
                            id="shipping-name"
                          >
                            {invoice.customer.name}
                          </p>
                          <p
                            className="text-muted mb-1"
                            id="shipping-address-line-1"
                          >
                            {invoice.shippingAddress.street}
                          </p>
                          <p className="text-muted mb-1">
                            {invoice.shippingAddress.city},{" "}
                            {invoice.shippingAddress.state}{" "}
                            {invoice.shippingAddress.postalCode}
                          </p>
                          <p className="text-muted mb-0">
                            <span>Email: </span>
                            <span id="shipping-email">
                              {invoice.customer.email}
                            </span>
                          </p>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Col>
                  <Col lg={12}>
                    <Card.Body className="p-4">
                      <div className="table-responsive">
                        <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                          <thead>
                            <tr className="table-active">
                              <th scope="col" style={{ width: "50px" }}>
                                #
                              </th>
                              <th scope="col">Product Details</th>
                              <th scope="col">Purity</th>
                              <th scope="col">Weight (g)</th>
                              <th scope="col">Rate (per g)</th>
                              <th scope="col">Quantity</th>
                              <th scope="col" className="text-end">
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody id="products-list">
                            {invoice.items.map((item, index) => (
                              <tr key={item._id}>
                                <th scope="row">{index + 1}</th>
                                <td className="text-start">
                                  <span className="fw-medium">
                                    {item.productName}
                                  </span>
                                  {item.productDetails && (
                                    <p className="text-muted mb-0">
                                      {item.productDetails}
                                    </p>
                                  )}
                                </td>
                                <td>{item.purity}</td>
                                <td>{item.weight.toFixed(2)}</td>
                                <td>₹{item.pricePerGram.toFixed(2)}</td>
                                <td>{item.quantity}</td>
                                <td className="text-end">
                                  ₹{item.totalPrice.toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div className="border-top border-top-dashed mt-2">
                        <Table
                          className="table-borderless table-nowrap align-middle mb-0 ms-auto"
                          style={{ width: "250px" }}
                        >
                          <tbody>
                            <tr>
                              <td>Sub Total</td>
                              <td className="text-end">
                                ₹{invoice.subTotal.toFixed(2)}
                              </td>
                            </tr>
                            {invoice.taxes > 0 && (
                              <tr>
                                <td>Tax</td>
                                <td className="text-end">
                                  ₹{invoice.taxes.toFixed(2)}
                                </td>
                              </tr>
                            )}
                            {invoice.discounts > 0 && (
                              <tr>
                                <td>Discount</td>
                                <td className="text-end">
                                  -₹{invoice.discounts.toFixed(2)}
                                </td>
                              </tr>
                            )}
                            <tr className="border-top border-top-dashed fs-15">
                              <th scope="row">Total Amount</th>
                              <th className="text-end">
                                ₹{invoice.finalAmount.toFixed(2)}
                              </th>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div className="mt-3">
                        <h6 className="text-muted text-uppercase fw-semibold mb-3">
                          Payment Details:
                        </h6>
                        <p className="text-muted mb-1">
                          Payment Method:{" "}
                          <span className="fw-medium" id="payment-method">
                            {invoice.paymentMode}
                          </span>
                        </p>
                        {invoice.paymentDetails && (
                          <p className="text-muted mb-1">
                            Details:{" "}
                            <span className="fw-medium" id="payment-details">
                              {invoice.paymentDetails}
                            </span>
                          </p>
                        )}
                        <p className="text-muted">
                          Total Amount:{" "}
                          <span className="fw-medium">
                            ₹{invoice.finalAmount.toFixed(2)}
                          </span>
                        </p>
                      </div>
                      <div className="mt-4">
                        <div className="alert alert-info">
                          <p className="mb-0">
                            <span className="fw-semibold">NOTES:</span>
                            <span id="note"> {invoice.notes}</span>
                          </p>
                        </div>
                      </div>
                      <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                        <button
                          onClick={printInvoice}
                          className="btn btn-success"
                        >
                          <i className="ri-printer-line align-bottom me-1"></i>{" "}
                          Print
                        </button>
                        <Link to="#" className="btn btn-primary">
                          <i className="ri-download-2-line align-bottom me-1"></i>{" "}
                          Download
                        </Link>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InvoiceDetails;
